import {ICompetition} from "../competitions/typings";

export const getCompetitionLabel = (competition: ICompetition) => {
    let areaLabel = '';
    if (competition.area) {
        areaLabel = competition.area.codeISO;
    }
    return areaLabel ? `${competition.name} (${areaLabel})` : competition.name;
};
